"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const osmHelpers_1 = require("./helpers/osmHelpers");
const pagination_1 = __importDefault(require("../pagination"));
class ShowPost {
    constructor(map, markers, container) {
        this.container = container;
        this.clusters = markers;
        this.map = map;
        this.sidebar = container.querySelector('.c-openstreetmap__sidebar');
        this.paginationInstance = false;
        const paginationTarget = this.container.querySelector('[data-js-pagination-target]');
        if (paginationTarget) {
            const instanceId = paginationTarget === null || paginationTarget === void 0 ? void 0 : paginationTarget.dataset.paginationInstance;
            if (instanceId) {
                const paginationInstance = pagination_1.default.getInstance(instanceId);
                if (paginationInstance) {
                    this.paginationInstance = paginationInstance;
                }
            }
        }
        if (this.map && this.container && this.clusters && this.sidebar) {
            this.setListeners();
            this.handleCoordinatesFromURLSearchParams();
        }
    }
    setListeners() {
        window.addEventListener('popstate', () => this.handleBackButton());
        const paginationContainer = this.container.querySelector('[data-js-pagination-container]');
        if (!paginationContainer)
            return;
        paginationContainer.addEventListener('keydown', (e) => {
            const keyboardEvent = e;
            const target = keyboardEvent.target;
            if (target && target.hasAttribute('data-js-pagination-item') && keyboardEvent.key === 'Enter') {
                const el = target.querySelector('.c-openstreetmap__collection__item');
                if (el) {
                    this.handleClick(el);
                }
            }
            if (keyboardEvent.key === 'Escape') {
                this.handleBackButton();
            }
        });
        paginationContainer.addEventListener('click', (e) => {
            let clickEl = e.target;
            this.handleClick(clickEl);
        });
    }
    handleCoordinatesFromURLSearchParams() {
        const params = (0, osmHelpers_1.getCoordinatesFromURLSearchParams)();
        if (!params || !this.sidebar)
            return;
        const posts = this.sidebar.querySelectorAll('.c-openstreetmap__collection__item');
        [...posts].forEach((collectionItem) => {
            const latLng = (0, osmHelpers_1.getMarkerDataFromElement)(collectionItem);
            const lat = latLng.lat;
            const lng = latLng.lng;
            if (lat && lng) {
                if (lat == params.lat && lng == params.lng) {
                    const parent = collectionItem.closest('[data-js-pagination-item]');
                    if (this.paginationInstance && parent && parent.getAttribute('data-js-pagination-page')) {
                        const page = parent.getAttribute('data-js-pagination-page');
                        if (!page)
                            return;
                        this.paginationInstance.paginateSetCurrent(parseInt(page));
                        this.paginationInstance.tableRefresh();
                    }
                    this.handleClick(collectionItem);
                }
            }
        });
    }
    handleClick(element) {
        if (!element || element.closest('.c-collection__item__floating'))
            return;
        const collectionItem = element.closest('.c-openstreetmap__collection__item');
        const paginationItem = collectionItem === null || collectionItem === void 0 ? void 0 : collectionItem.parentElement;
        const backButton = element.closest('.c-openstreetmap__post-icon');
        const moduleArea = document.getElementById('sidebar-right-sidebar');
        if (paginationItem && this.sidebar) {
            paginationItem.className = '';
            paginationItem.classList.add('is-active');
            this.sidebar.classList.add('has-active');
            paginationItem.classList.remove('u-display--none');
            if (moduleArea) {
                moduleArea.classList.add('u-display--none');
            }
            const latLng = (0, osmHelpers_1.getMarkerDataFromElement)(collectionItem);
            const lat = latLng.lat;
            const lng = latLng.lng;
            (0, osmHelpers_1.pushCoordinatesToBrowserHistory)({ lat: lat, lng: lng });
            this.scrollToTop();
        }
        if (backButton) {
            this.handleBackButton();
            if (moduleArea) {
                moduleArea.classList.remove('u-display--none');
            }
        }
    }
    scrollToTop() {
        var _a;
        if (!this.sidebar)
            return;
        const rect = this.sidebar.getBoundingClientRect();
        let offset = 0;
        const topPos = window.pageYOffset || document.documentElement.scrollTop;
        if (document.querySelector('.c-header--sticky')) {
            const header = document.querySelector('.c-header--sticky');
            if (!header)
                return;
            const headerRect = header.getBoundingClientRect();
            offset = (_a = headerRect.height) !== null && _a !== void 0 ? _a : 100;
        }
        const target = rect.top + topPos - offset;
        window.scrollTo({
            top: target,
        });
    }
    handleBackButton() {
        if (!this.sidebar)
            return;
        if (this.sidebar.classList.contains('has-active')) {
            this.sidebar.classList.remove('has-active');
        }
        this.sidebar.querySelectorAll('[data-js-pagination-item]').forEach((item) => {
            item.classList.remove('is-active');
        });
        (0, osmHelpers_1.pushCoordinatesToBrowserHistory)({ lat: undefined, lng: undefined });
    }
}
exports.default = ShowPost;
